import { getCloudKey } from "@/api/cos.js";
import COS from "cos-js-sdk-v5";

export default function useCosUpload(bucket) {
  let taskId = null; //任务id
  const cos = new COS({
    ForcePathStyle: false,
    getAuthorization: getAuthorizationv2,
    ProgressInterval: 500,
  });

  function getAuthorizationv2(options, callback) {
    getCloudKey().then((res) => {
      if (res.code !== 100) {
        callback({});
        return;
      }
      let data = res.data;
      let credentials = data && data.credentials;
      callback({
        TmpSecretId: credentials.tmpSecretId,
        TmpSecretKey: credentials.tmpSecretKey,
        XCosSecurityToken: credentials.sessionToken,
        StartTime: data.startTime,
        ExpiredTime: data.expiredTime,
      });
    });
  }
  /**
   *上传文件
   * @param {*} path 储存桶存储目录例：/share/haipc/xxx.png
   * @param {*} fileName 文件名称
   * @param {*} fileObject 文件对象选择文件后浏览器返回的数据
   * @param {*} requestCallback 回调函数
   */
  function uploadFiles(path, fileName, fileObject, requestCallback, progress) {
    cos.uploadFile(
      {
        Bucket: bucket,
        Region: 'ap-guangzhou',
        Key: path + fileName,
        Body: fileObject,
        SliceSize: 1024 * 1024 * 20,
        onTaskReady(id) {
          taskId = id;
        },
        onProgress(progressData) {
          progress(progressData)
        },
        onFileFinish(err, data, options) {
          console.log(options.Key + '上传' + (err ? '失败' : '完成'));
        },
      },
      requestCallback
    );
  }

  /**
   *取消上传
   */
  function cancelUpload() {
    console.log("取消", taskId);
    cos.cancelTask(taskId);
  }

  /**
   * 删除上传任务ID
   */
  function clearTaskId() {
    taskId = null;
  }

  return {
    uploadFiles,
    cancelUpload,
    clearTaskId,
  };
}



// WEBPACK FOOTER //
// ./src/api/cos/index.js